import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import LoginPage          from './pages/LoginPage';
import DashboardPage      from './pages/DashboardPage';
import AsignaturaPage     from './pages/AsignaturaPage';
import AnunciosPage       from './pages/AnunciosPage';
import MensajesPage       from './pages/MensajesPage';
import ContenidosPage     from './pages/ContenidosPage';
import TrabajosPage       from './pages/TrabajosPage';
import CalificacionesPage from './pages/CalificacionesPage';
import NotasPage          from './pages/NotasPage';
import AdminPage          from './pages/AdminPage';
import PerfilPage         from './pages/PerfilPage';
import SoportePage        from './pages/SoportePage';

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route index                                 element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard"                      element={<DashboardPage />} />
              <Route path="perfil"                         element={<PerfilPage />} />
              <Route path="admin"                          element={<AdminPage />} />
              <Route path="soporte"                        element={<SoportePage />} />
              <Route path="asignaturas/:id"                element={<AsignaturaPage />} />
              <Route path="asignaturas/:id/anuncios"       element={<AnunciosPage />} />
              <Route path="asignaturas/:id/mensajes"       element={<MensajesPage />} />
              <Route path="asignaturas/:id/contenidos"     element={<ContenidosPage />} />
              <Route path="asignaturas/:id/trabajos"       element={<TrabajosPage />} />
              <Route path="asignaturas/:id/calificaciones" element={<CalificacionesPage />} />
              <Route path="asignaturas/:id/notas"          element={<NotasPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}
